import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-daterange', 'TIME_START', 'Algaeg');
Labels.set('ui-daterange', 'TIME_END', 'Lōppaeg');
